<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style lang="scss">

.k-toolbar.k-editor-toolbar.k-toolbar-resizable{
  display: none;
}

.k-content{
  width: 100%!important;
  height: 100%!important;
}

/* Style for scrollbar */

/* width */
#element::-webkit-scrollbar {
    width: 3px;
}
  
/* Track */
#element::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
#element::-webkit-scrollbar-thumb {
    background: #0d4e4d;
}

/* Handle on hover */
#element::-webkit-scrollbar-thumb:hover {
    background: #326b75;
}


</style>
